const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getToken() { return localStorage.getItem("anx_token") || ""; }
export function setToken(t) { t ? localStorage.setItem("anx_token", t) : localStorage.removeItem("anx_token"); }

export async function api(method, path, body) {
  const res = await fetch(`${API}${path}`, {
    method,
    headers: { "Content-Type": "application/json", ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = {};
  try { data = await res.json(); } catch (e) { console.debug("No JSON body in response:", e); }
  if (!res.ok) {
    const d = data && data.detail;
    throw new Error(typeof d === "string" ? d : Array.isArray(d) ? d.map((e) => e.msg).join(" ") : "Request failed");
  }
  return data;
}
